import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';
import clsx from 'clsx';

import scss from './PanelHandle.module.scss';

const SHAPE_FILL = 'M0 0 C0 12 15 14 15 28 V68 C15 82 0 84 0 96 Z';
const SHAPE_STROKE = 'M0.5 0 C0.5 12 15 14 15 28 V68 C15 82 0.5 84 0.5 96';

function PanelHandle({ isCollapsed, onToggle }) {
  const { t } = useTranslation('mediaStudio');
  const label = isCollapsed ? t('expandPanel') : t('collapsePanel');

  return (
    <button
      type='button'
      className={clsx(scss.handle, isCollapsed && scss.handleCollapsed)}
      title={label}
      aria-label={label}
      aria-expanded={!isCollapsed}
      onClick={onToggle}>
      <svg className={scss.shape} width='16' height='96' viewBox='0 0 16 96' aria-hidden='true'>
        <path className={scss.base} d={SHAPE_FILL} />
        <path className={scss.fill} d={SHAPE_FILL} />
        <path className={scss.stroke} d={SHAPE_STROKE} />
      </svg>
      <ChevronLeft className={scss.chevron} size={14} strokeWidth={2.5} />
    </button>
  );
}

export default PanelHandle;
